/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_UploadedInputs */

const en_media_uploaded = /** @type {(inputs: Media_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media uploaded successfully!`)
};

const id_media_uploaded = /** @type {(inputs: Media_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media berhasil diunggah!`)
};

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const es_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const fr_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const de_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const ja_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const zh_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const ar_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const it_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const ru_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const pt_media_uploaded = en_media_uploaded;

/** @type {(inputs: Media_UploadedInputs) => LocalizedString} */
const ko_media_uploaded = en_media_uploaded;

/**
* | output |
* | --- |
* | "Media uploaded successfully!" |
*
* @param {Media_UploadedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_uploaded = /** @type {((inputs?: Media_UploadedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_UploadedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_uploaded(inputs)
	if (locale === "es") return es_media_uploaded(inputs)
	if (locale === "fr") return fr_media_uploaded(inputs)
	if (locale === "de") return de_media_uploaded(inputs)
	if (locale === "ja") return ja_media_uploaded(inputs)
	if (locale === "zh") return zh_media_uploaded(inputs)
	if (locale === "ar") return ar_media_uploaded(inputs)
	if (locale === "id") return id_media_uploaded(inputs)
	if (locale === "it") return it_media_uploaded(inputs)
	if (locale === "ru") return ru_media_uploaded(inputs)
	if (locale === "pt") return pt_media_uploaded(inputs)
	return ko_media_uploaded(inputs)
});